/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __assign, __rest } from "tslib";
import React from "react";
import { ICON_SIZE_STANDARD, ICON_SIZE_LARGE } from "../../constants";
import * as Classes from "../../classes";
export var ChevronUp = function (_a) {
    var className = _a.className, color = _a.color, _b = _a.size, size = _b === void 0 ? ICON_SIZE_STANDARD : _b, _c = _a.title, title = _c === void 0 ? "chevron-up" : _c, _d = _a.htmlTitle, htmlTitle = _d === void 0 ? title : _d, _e = _a.tagName, tagName = _e === void 0 ? "span" : _e, htmlProps = __rest(_a, ["className", "color", "size", "title", "htmlTitle", "tagName"]);
    var isLarge = size >= ICON_SIZE_LARGE;
    var pixelGridSize = isLarge ? ICON_SIZE_LARGE : ICON_SIZE_STANDARD;
    var viewBox = "0 0 " + pixelGridSize + " " + pixelGridSize;
    var path = (React.createElement("path", { d: isLarge
            ? "M16.71 7.71L10.71 13.71C10.53 13.89 10.28 14 10 14S9.47 13.89 9.29 13.71L3.29 7.71C3.11 7.53 3 7.28 3 7C3 6.45 3.45 6 4 6C4.28 6 4.53 6.11 4.71 6.29L10 11.59L15.29 6.3C15.47 6.11 15.72 6 16 6C16.55 6 17 6.45 17 7C17 7.28 16.89 7.53 16.71 7.71z"
            : "M12.71 6.71L8.71 10.71C8.53 10.89 8.28 11 8 11S7.47 10.89 7.29 10.71L3.29 6.71C3.11 6.53 3 6.28 3 6C3 5.45 3.45 5 4 5C4.28 5 4.53 5.11 4.71 5.29L8 8.59L11.29 5.3C11.47 5.11 11.72 5 12 5C12.55 5 13 5.45 13 6C13 6.28 12.89 6.53 12.71 6.71z", fillRule: "evenodd" }));
    if (tagName === null) {
        return (React.createElement("svg", __assign({ fill: color, "data-icon": "chevron-up", width: size, height: size, viewBox: viewBox }, htmlProps),
            title && React.createElement("desc", null, title),
            path));
    }
    else {
        return React.createElement(tagName, __assign(__assign({}, htmlProps), { className: className + " " + Classes.ICON, title: htmlTitle }), React.createElement("svg", { fill: color, "data-icon": "chevron-up", width: size, height: size, viewBox: viewBox },
            title && React.createElement("desc", null, title),
            path));
    }
};
export default ChevronUp;
//# sourceMappingURL=chevron-up.js.map